import { Link } from 'react-router-dom';
import SEOHead from '../../components/SEOHead';

interface Product {
  id: number;
  name: string;
  description: string;
  price: string;
  image: string;
  amazonLink: string;
}

const products: Product[] = [
  {
    id: 1,
    name: "Loop Quiet 2 Earplugs",
    description: "Reusable, soft silicone earplugs that reduce noise by 24dB. They are stylish, comfortable for sleeping, and stay in your ears.",
    price: "$24.95",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/af9a6aae5a09e62b3f9d0f917c5e83a3.png",
    amazonLink: "https://amzn.to/4jSNcJl"
  },
  {
    id: 2,
    name: "Bagsmart Electronics Organizer",
    description: "A slim pouch with elastic loops to keep all your cables, chargers, and SD cards untangled and easy to find.",
    price: "$19.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/1e4946dcc16a0ee796b2a598b5f9bdf4.png",
    amazonLink: "https://amzn.to/4qNGDKc"
  },
  {
    id: 3,
    name: "INIU Portable Charger",
    description: "The \"paw print\" power bank is the best-selling budget charger. It's slim, lightweight, and supports high-speed charging.",
    price: "$15.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/42e7ea54365c3292806a63b6e4c7119a.png",
    amazonLink: "https://amzn.to/45XPQaT"
  },
  {
    id: 4,
    name: "Perilogics Universal Airplane Phone Mount",
    description: "A clever clamp that attaches your phone to the tray table latch, letting you watch movies hands-free at eye level.",
    price: "$12.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/920618feb8a9a2dc6a214df112de47af.png",
    amazonLink: "https://amzn.to/45K5vKQ"
  },
  {
    id: 5,
    name: "Gonex Compression Packing Cubes",
    description: "Unlike regular cubes, these have a second zipper that compresses your clothes, saving up to 40% of space in your suitcase.",
    price: "$29.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/99e012eb2f0c260a930d419b26718c9c.png",
    amazonLink: "https://amzn.to/49qJdAh"
  },
  {
    id: 6,
    name: "LiquiSnugs Silicone Travel Bottles",
    description: "Leak-proof, squeezable silicone bottles that are TSA-approved and feature suction cups to stick to shower walls.",
    price: "$16.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/03fce8a5d17a2209b13a8281be08b94e.png",
    amazonLink: "https://amzn.to/3NlQcBP"
  },
  {
    id: 7,
    name: "Hatch Rest Go",
    description: "A sound machine that clips onto strollers or bags, great for drowning out hotel noise for babies (and adults!).",
    price: "$59.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/cc08878ba53af8e56b77fe13d5608572.png",
    amazonLink: "https://amzn.to/4pJorAH"
  },
  {
    id: 8,
    name: "Airplane Foot Hammock",
    description: "A memory foam footrest that hangs from the tray table, preventing leg swelling and lower back pain on long flights.",
    price: "$19.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/9786a46833ea994e107cebe76727fb38.png",
    amazonLink: "https://amzn.to/3NoLGm3"
  },
  {
    id: 9,
    name: "Benevolence LA Velvet Jewelry Box",
    description: "Oprah's \"Favorite Thing\" that keeps jewelry organized and untangled in a compact, luxurious travel case.",
    price: "$39.99",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/36056038a89c44a753095ea876dd26c1.png",
    amazonLink: "https://amzn.to/4pFvI4g"
  },
  {
    id: 10,
    name: "LifeStraw Go Series Water Bottle",
    description: "Essential for international travel, this bottle has a built-in filter that removes bacteria and parasites from tap water.",
    price: "$44.95",
    image: "https://static.readdy.ai/image/918694c0b33b18123a4b53c7a1500734/827abd438f0f9b5061e0f189f6fc8435.png",
    amazonLink: "https://amzn.to/4sHyR6B"
  }
];

export default function TravelMustHavesPage() {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Travel Must-Haves - Essential Travel Gear",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/travel-must-haves`,
    "description": "Genius organizers and gadgets to make flying easier. Top-rated travel essentials including Loop Earplugs, packing cubes, portable chargers, and more.",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": products.map((product, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@type": "Product",
          "name": product.name,
          "description": product.description,
          "offers": {
            "@type": "Offer",
            "price": product.price.replace('$', ''),
            "priceCurrency": "USD",
            "availability": "https://schema.org/InStock",
            "url": product.amazonLink
          }
        }
      }))
    }
  };

  return (
    <>
      <SEOHead
        title="Travel Must-Haves - Essential Travel Gear & Organizers"
        description="Discover genius travel organizers and gadgets including Loop Quiet Earplugs, Bagsmart Electronics Organizer, compression packing cubes, and more. Make flying easier with these travel essentials."
        keywords="travel must-haves, travel essentials, travel gear, packing cubes, travel organizers, airplane accessories, travel gadgets"
        canonicalPath="/travel-must-haves"
        schemaData={schemaData}
      />
      <div className="min-h-screen w-full animated-gradient px-4 py-12">
        <div className="w-full max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <Link 
              to="/" 
              className="inline-flex items-center gap-2 text-white/90 hover:text-white mb-6 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line text-2xl"></i>
              <span className="text-lg">Back to Home</span>
            </Link>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4">
              🧳 Travel Must-Haves
            </h1>
            <p className="text-white/90 text-lg md:text-xl">
              Genius organizers and gadgets to make flying easier
            </p>
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {products.map((product) => (
              <div 
                key={product.id}
                className="bg-white/95 backdrop-blur-sm rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="w-full h-64 overflow-hidden">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{product.name}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4 flex-grow">{product.description}</p>
                  <div className="flex items-center justify-end mt-auto">
                    <a
                      href={product.amazonLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-gradient-to-r from-[#d4a574] to-[#e4b584] hover:from-[#c49564] hover:to-[#d4a574] text-white font-semibold py-3 px-6 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
                    >
                      <span>View on Amazon</span>
                      <i className="ri-amazon-fill text-xl"></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Footer */}
          <div className="text-center space-y-4">
            <p className="text-white/90 text-sm md:text-base">
              As an Amazon Associate, I earn from qualifying purchases support the hustle 💋
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
